import { InputField } from "@rawa/ui/InputField"
import { TextArea } from "@rawa/ui/TextArea"

const NAME_TAKEN_MESSAGE = "There is already a module with this name."

/** A module's name and description, as set up and as edited. */
export function ModuleNameFields({
  name,
  description,
  onNameChange,
  onDescriptionChange,
  nameTaken,
}: {
  name: string
  description: string
  onNameChange: (name: string) => void
  onDescriptionChange: (description: string) => void
  nameTaken: boolean
}) {
  return (
    <>
      <InputField
        id="module-name"
        label="Module name"
        value={name}
        onChange={onNameChange}
        error={nameTaken ? NAME_TAKEN_MESSAGE : undefined}
        required
        maxLength={200}
      />

      <TextArea
        id="module-description"
        label="Module description"
        value={description}
        onChange={onDescriptionChange}
        placeholder="Explain what the module captures and when it is used"
        required
        maxLength={2000}
      />
    </>
  )
}
